import React, { memo, useMemo } from 'react';
import Iframe from 'react-iframe';
import ScrollContainer from './ScrollContainer';

const CommonIframe = ({ url }) => {
    // Memoize the URL to avoid unnecessary re-renders
    const memoizedUrl = useMemo(() => url, [url]);
    const { innerWidth: width, innerHeight: height } = window;

    return (
        // <ScrollContainer maxHeight={'580px'}>
        <div className="pdf-container">
            <iframe
                src={memoizedUrl} // Use the memoized URL
                id="Iframe1"
                name="frameMain"
                width="100%"
                height={height - 200}
                style={{ border: "1px solid gray" }}
                scrolling="yes"
                position="relative"
                // sandbox="allow-same-origin allow-scripts allow-popups"
                // allow="autoplay; encrypted-media"
            />
        </div>
        // </ScrollContainer>
    );
};

export default memo(CommonIframe);
